export function getModelListReactPath(): string {
  return '/model'
}

export function getModelListUrl(): string {
  return getModelListReactPath()
}

export function getModelAddReactPath(): string {
  return '/model/add'
}

export function getModelAddUrl(): string {
  return getModelAddReactPath()
}

export function getModelEditReactPath(modelId: string | number): string {
  return `/model/edit/${modelId}`
}

export function getModelEditUrl(modelId: string | number): string {
  return getModelEditReactPath(modelId)
}
